import Util from '../../common/js/util.js';
import Common from '../../common/js/common.js';
import {Request} from "../../common/request";
import Vue from 'vue'
import qs from 'qs'
import config from '../../config/config.js';

// 获取字典
const getDicInfoByKey = obj => Request('Common/Common/getDicInfoByKey', 'GET', obj)

// 获取协议
const getInfoByTag = obj => Request('App/Currency/getInfoByTag', 'POST', obj)

// 获取用户信息
const getUserInfo = obj => Request('Fortune/User/getInfo', 'GET', obj)

// 分享配置
const fetchShareConfig = obj => Request('Fortune/Index/fetchShareConfig', 'GET', obj)

// 获取域名配置
const getConfig = obj => Request('Fortune/Index/getConfig', 'GET', obj)

function wxUrl() {
  const scope = 'snsapi_userinfo'
  const searchJson = Util.getSearchJson()
  delete searchJson.code
  delete searchJson.state
  delete searchJson.force
  const searchJsonStr = qs.stringify(searchJson)
  const callbackUrl = window.location.origin + window.location.pathname + (searchJsonStr ? '?' + searchJsonStr : '') + window.location.hash
  const url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.Wx_appid + '&redirect_uri=' + encodeURIComponent(callbackUrl) + '&response_type=code&scope=' + scope + '&state=STATE#wechat_redirect'
  window.history.replaceState({}, null, callbackUrl)
  window.history.pushState({go: -1}, null, callbackUrl)
  window.history.pushState({go: -3}, null, callbackUrl)
  window.history.pushState({go: -4}, null, callbackUrl)
  window.location.href = url
}

function getWxCode() {
  if (Common.isWeiXin) {         //如果是微信
    const weixin_code = Util.getUrlParams('code');
    if (!weixin_code) {
      wxUrl();
    } else {
      return weixin_code;
    }
  }
}

export default {
  wxLogin(url, inviteCode) {
    return new Promise((resolve, reject) => {
      const wxCode = getWxCode()
      if (!wxCode) {
        return
      }
      Vue.$vux.loading.show({
        text: '正在登录'
      })
      Request(url, 'POST', {
        code: wxCode,
        inviteCode: inviteCode,
      }).then(data => {
        Vue.$vux.loading.hide()
        if (data.Status === 200) {
          resolve()
        } else {
          reject()
        }
      }).catch(() => {
        Vue.$vux.loading.hide()
        reject()
      })
    })
  },
  getDicInfoByKey,
  getInfoByTag,
  getUserInfo,
  fetchShareConfig,
  getConfig
}



// WEBPACK FOOTER //
// ./src/api/global/index.js